import { GatsbyImage, getImage } from 'gatsby-plugin-image'

const Image = ({
  src,
  alt,
  className,
  layout,
  sizes,
  loading = 'eager',
  ...props
}) => {
  let boxImage
  if (typeof src === 'object') {
    boxImage = (
      <GatsbyImage
        image={getImage(src)}
        alt={alt || ''}
        loading={loading}
        className={className}
        layout={layout}
        sizes={sizes}
        {...props}
      />
    )
  } else {
    boxImage = <img src={src} alt={alt} className={className} />
  }
  return boxImage
}

export default Image
